import React from "react";
import { Pagination } from "antd";

export default function PaginationComp(props) {
  const changePage = (selectedPage) => {
    props.setPagination(selectedPage);
  };
  const total_pages = Math.ceil(props.totals / props.pageCount);
  if (total_pages == 1 && props.page == 1) return <div />;
  if (total_pages == 0) return <div />;

  return (
    <ul
      className={`pagination d-flex justify-content-center ${
        props.className || ""
      }`}
    >
      <Pagination
        simple
        current={props.page}
        pageSize={props.pageCount}
        total={props.totals}
        onChange={(e) => changePage(e)}
      />
    </ul>
  );
}
